/**
 * BRANDING CONFIGURATION
 * ======================
 * This file contains all branding-related settings for the e-commerce site.
 * Update these values to customize the site for your client.
 */

const brandingConfig = {
  // ========================================
  // BUSINESS NAME & IDENTITY
  // ========================================
  businessName: 'Xiluva Botanicals (Pty) Ltd',
  businessNameShort: 'Xiluva Botanicals', // Used in compact displays
  businessTagline: 'Natural Wellness & Botanical Products', // Used in page titles and meta descriptions
  businessDescription: 'Premium botanical products including herbal powders, teas, wellness supplements, and natural skincare.',

  // ========================================
  // COLORS
  // ========================================
  colors: {
    // Primary brand color (used for buttons, links, accents)
    primary: '#d6cabb',          // Pastel Gray Orange
    primaryDark: '#c4b5a3',      // Darker shade for hover states
    primaryLight: '#e4ddd4',     // Lighter shade for highlights

    // Text colors
    textPrimary: '#43301b',      // Day Gray Orange
    textSecondary: '#000000',    // Black
    textTertiary: '#6b6b6b',     // Tertiary/muted text

    // Background colors
    background: '#ffffff',
    backgroundSubtle: '#fafafa', // Light gray backgrounds

    // UI elements
    border: 'rgba(0, 0, 0, 0.08)',
    shadow: 'rgba(0, 0, 0, 0.1)',
  },

  // ========================================
  // TYPOGRAPHY
  // ========================================
  typography: {
    // Font families
    fontDisplay: "'Bauer Bodoni', Georgia, serif",  // For headings and product names
    fontBody: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", // For product info and directions
    fontDescription: "'Noto Serif Ethiopic', Georgia, serif", // For product descriptions

    // Google Fonts URL (update if changing fonts)
    googleFontsUrl: 'https://fonts.googleapis.com/css2?family=Noto+Serif+Ethiopic:wght@300;400;500;600;700&family=Montserrat:wght@300;400;500;600;700&display=swap',

    // Font weights
    fontWeights: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },

  // ========================================
  // LOGO & IMAGES
  // ========================================
  logos: {
    // Main logo for header (supports WebP, PNG, SVG)
    header: '/header-logo.webp',
    headerFallback: '/header-logo.png',

    // Favicon (square, preferably 512x512px)
    favicon: '/Gs.webp',
    faviconFallback: '/Gs.png',

    // Apple touch icon
    appleTouchIcon: '/Gs.webp',

    // Open Graph image (for social media sharing)
    ogImage: '/Gs.webp',
  },

  // ========================================
  // META & SEO
  // ========================================
  meta: {
    // Page title template: {PAGE} | {businessName}
    titleTemplate: '%s | Xiluva Botanicals',
    defaultTitle: 'Xiluva Botanicals - Natural Wellness & Botanical Products',

    // Meta description (155-160 characters recommended)
    description: 'Xiluva Botanicals - Premium botanical products including herbal powders, teas, wellness supplements, natural skincare, and spiritual cleansing products.',

    // Keywords for SEO
    keywords: 'botanicals, herbal products, natural wellness, teas, powders, skincare, yoni steaming, spiritual cleansing, South Africa, Xiluva Botanicals',

    // Theme color (for mobile browsers)
    themeColor: '#d6cabb',

    // Open Graph / Social media
    ogTitle: 'Xiluva Botanicals - Natural Wellness & Botanical Products',
    ogDescription: 'Premium botanical products including herbal powders, teas, wellness supplements, and natural skincare.',

    // Twitter card
    twitterTitle: 'Xiluva Botanicals - Natural Wellness & Botanical Products',
    twitterDescription: 'Premium botanical products including herbal powders, teas, wellness supplements, and natural skincare.',
  },

  // ========================================
  // MANIFEST (PWA settings)
  // ========================================
  manifest: {
    shortName: 'Xiluva Botanicals',
    name: 'Xiluva Botanicals - Natural Wellness & Botanical Products',
    backgroundColor: '#ffffff',
    themeColor: '#d6cabb',
  },
};

export default brandingConfig;
